// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__GSj6+","pseudoNav":"nav_pseudoNav__YCJii","logo":"nav_logo__02r+V","navList":"nav_navList__TOkU5","listItem":"nav_listItem__+VWat","selected":"nav_selected__90EX0"};